/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2021-05-25 16:14:00
 *
 *******************************************************/
// @flow

import { Loading } from '@shopify/app-bridge/actions';
import { getSABAppInstance_Normal } from './app';

let SABLoadingInstance = null;

function createSABLoadingInstance() {
  SABLoadingInstance = Loading.create(getSABAppInstance_Normal());
}

export function startSABLoading() {
  if (!SABLoadingInstance) createSABLoadingInstance();
  SABLoadingInstance.dispatch(Loading.Action.START);
}

export function stopSABLoading() {
  if (!SABLoadingInstance) createSABLoadingInstance();
  SABLoadingInstance.dispatch(Loading.Action.STOP);
}
